import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-date-cell-renderer",
  templateUrl: "./date-cell-renderer.component.html",
  styleUrls: ["./date-cell-renderer.component.scss"],
})
export class DateCellRendererComponent implements OnDestroy {
  params: any;
  date: any;
  isToday:boolean = false;
  appCustomDate: any;
  private destroy$ = new Subject<void>();
  agInit(params: any): void {
    this.params = params;
    if (this.params.value) {
      this.date = new Date(this.params.value);
      this.appCustomDate = {
        date: this.date,
        dateFormat: this.params.dateFormat && typeof this.params.dateFormat === 'string' ?
            this.params.dateFormat: 'MM/dd/yy'
      }
      if (new Date().toDateString() === this.date.toDateString()) {
        this.isToday = true;
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
